module.exports = __webpack_public_path__ + "img/person-walk.34feb9eb.svg";